import { LoginPayload, LoginResponse } from "../../../models/User";
import ApiClient from "../../apiClient";
import mutationWrapper from "../mutationWrapper";

export async function login(data: LoginPayload): Promise<LoginResponse> {
  const res = await ApiClient.post(`/Login`, data);
  return res.data;
}

export const useLogin = mutationWrapper(login);
